(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aot-hero-search"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.aot-hero-root').forEach(function (el) {
    if (el.dataset.aotInit) return;
    el.dataset.aotInit = '1';
    var seg = el.querySelector('[data-aot-seg]');
    var field = el.querySelector('[data-aot-sector-field]');
    if (!seg) return;
    seg.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        seg.querySelectorAll('button').forEach(function (x) {
          x.classList.remove('active');
          x.setAttribute('aria-pressed', 'false');
        });
        b.classList.add('active');
        b.setAttribute('aria-pressed', 'true');
        el.dataset.sector = b.dataset.s;
        // Such-Filter auf den aktiven Sektor setzen (falls aktiviert)
        if (field && b.dataset.filter) field.value = b.dataset.filter;
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aot-interaktive-broschuere"] && !Shopify.designMode) return;
  try {
    
(() => {
  const SELECTOR = '[data-aot-brochure]';
  const qs = (root, sel) => root.querySelector(sel);
  const qsa = (root, sel) => [...root.querySelectorAll(sel)];

  function reduceMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function init(root) {
    if (!root || root.dataset.aotInitialized === 'true') return;
    root.dataset.aotInitialized = 'true';
    let T = {};
    try { T = JSON.parse(root.dataset.i18n || '{}'); } catch (e) { T = {}; }
    T = Object.assign({ page_alt: 'AOT Broschürenseite', page: 'Seite', open_gallery: 'Bildergalerie öffnen', open_website: 'Website öffnen', open_film: 'AOT Imagefilm öffnen', enquire: 'AOT Food Ingredients anfragen', interactive_area: 'Interaktiver Bereich', previous_image: 'Vorheriges Bild', next_image: 'Nächstes Bild', team_company: 'AOT – Team & Unternehmen', company_film: 'AOT Imagefilm', link_copied: 'Link kopiert', link_copy_failed: 'Link konnte nicht kopiert werden', areas_visible: 'Interaktive Bereiche sichtbar', areas_hidden: 'Interaktive Bereiche ausgeblendet' }, T);

    const pages = qsa(root, '[data-aot-page-source]')
      .map((el, index) => ({ src: el.dataset.src || '', alt: el.dataset.alt || `${T.page_alt} ${index + 1}` }))
      .filter(page => page.src);

    const gallery = qsa(root, '[data-aot-gallery-source]')
      .map(el => ({ src: el.dataset.src || '', alt: el.dataset.alt || '' }))
      .filter(item => item.src);

    const spread = qs(root, '[data-aot-spread]');
    const viewport = qs(root, '[data-aot-viewport]');
    const counter = qs(root, '[data-aot-counter]');
    const progress = qs(root, '[data-aot-progress]');
    const drawer = qs(root, '[data-aot-drawer]');
    const thumbsList = qs(root, '[data-aot-thumbs-list]');
    const scrim = qs(root, '[data-aot-scrim]');
    const modal = qs(root, '[data-aot-modal]');
    const modalTitle = qs(root, '[data-aot-modal-title]');
    const modalMeta = qs(root, '[data-aot-modal-meta]');
    const modalBody = qs(root, '[data-aot-modal-body]');
    const toast = qs(root, '[data-aot-toast]');
    const viewerCard = qs(root, '[data-aot-viewer-card]');
    const zoomLabel = qs(root, '[data-aot-zoom-label]');
    const sectionId = root.dataset.sectionId || '';

    let current = 1;
    let zoom = 1;
    let galleryIndex = 0;
    let toastTimer;
    let touchX = 0;

    const isMobile = () => matchMedia('(max-width:900px)').matches;

    function track(event, data = {}) {
      const payload = Object.assign({ event, aot_section_id: sectionId }, data);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
      document.dispatchEvent(new CustomEvent('aot:brochure:event', { detail: payload }));
    }

    function showToast(message) {
      if (!toast) return;
      clearTimeout(toastTimer);
      toast.textContent = message;
      toast.classList.add('is-show');
      toastTimer = setTimeout(() => toast.classList.remove('is-show'), 1500);
    }

    function visiblePages() {
      const count = pages.length;
      if (count === 0) return [];
      if (isMobile() || current === 1 || current === count) return [current];
      const left = current % 2 === 0 ? current : current - 1;
      return [left, Math.min(left + 1, count)];
    }

    function linkHotspot(url, x, y, w, h, label) {
      return url ? { type: 'link', url, x, y, w, h, label } : null;
    }

    function hotspotsFor(pageNo) {
      const d = root.dataset;
      const map = {
        2: gallery.length ? [
          { type: 'gallery', x: 0, y: 0, w: 100, h: 39, label: T.open_gallery },
          { type: 'gallery', x: 50, y: 47, w: 50, h: 39, label: T.open_gallery }
        ] : [],
        4: [linkHotspot(d.linkEhv, 5.5, 78.4, 88.5, 18.6, 'EHV – ' + T.open_website)],
        5: [
          linkHotspot(d.linkKrueger, 5.7, 78.4, 43.2, 18.6, 'Krüger Behältersysteme – ' + T.open_website),
          linkHotspot(d.linkDalla, 51.1, 78.4, 43.2, 18.6, 'Dalla Betta – ' + T.open_website)
        ],
        6: [linkHotspot(d.linkEpple, 5.5, 82.5, 88.5, 14, 'Epple Internationale Spedition – ' + T.open_website)],
        7: [linkHotspot(d.linkRubin, 5.5, 82.3, 88.5, 14.3, 'Rubinmühle – ' + T.open_website)],
        8: [linkHotspot(d.linkNoerpel, 5.5, 83, 43, 13.5, 'Noerpel – ' + T.open_website)],
        9: [
          linkHotspot(d.linkAoel, 11, 28, 34, 11, 'AöL – ' + T.open_website),
          linkHotspot(d.linkNeubauer, 5.5, 57.2, 42, 12, 'Neubauer Liebl – ' + T.open_website),
          linkHotspot(d.linkWaldland, 5.5, 69.3, 42, 20, 'Waldland – ' + T.open_website)
        ],
        11: [linkHotspot(d.linkSecum, 5.5, 82.4, 88.5, 14, 'SECUM – ' + T.open_website)],
        12: [
          { type: 'video', x: 24, y: 34, w: 53, h: 33, label: T.open_film },
          { type: 'contact', x: 17, y: 77, w: 66, h: 12, label: T.enquire }
        ]
      };
      return (map[pageNo] || []).filter(Boolean);
    }

    function createHotspot(h, pageNo) {
      const el = document.createElement(h.type === 'link' ? 'a' : 'button');
      el.className = 'aot-brochure__hotspot';
      el.dataset.type = h.type;
      el.setAttribute('aria-label', h.label || T.interactive_area);
      Object.assign(el.style, { left: `${h.x}%`, top: `${h.y}%`, width: `${h.w}%`, height: `${h.h}%` });

      if (h.type === 'link') {
        el.href = h.url;
        el.target = '_blank';
        el.rel = 'noopener noreferrer';
        el.addEventListener('click', () => track('aot_brochure_supplier_click', { brochure_page: pageNo, url: h.url }));
      } else if (h.type === 'gallery') {
        el.type = 'button';
        el.addEventListener('click', () => openGallery(pageNo));
      } else if (h.type === 'video') {
        el.type = 'button';
        el.addEventListener('click', () => openVideo('page_hotspot', pageNo));
      } else if (h.type === 'contact') {
        el.type = 'button';
        el.addEventListener('click', () => openContact(pageNo));
      }
      return el;
    }

    function createPage(pageNo, cls) {
      const item = pages[pageNo - 1];
      const pageEl = document.createElement('div');
      pageEl.className = `aot-brochure__page ${cls}`;
      const img = document.createElement('img');
      img.src = item.src;
      img.alt = item.alt || `${T.page_alt} ${pageNo}`;
      img.loading = pageNo <= 2 ? 'eager' : 'lazy';
      img.decoding = 'async';
      img.draggable = false;
      pageEl.appendChild(img);
      hotspotsFor(pageNo).forEach(h => pageEl.appendChild(createHotspot(h, pageNo)));
      return pageEl;
    }

    function render(direction = '') {
      if (!spread) return;
      if (!pages.length) {
        spread.innerHTML = window.Shopify && window.Shopify.designMode ? '<div class="aot-brochure__empty">Bitte im Theme-Editor die Broschürenseiten auswählen.</div>' : '';
        return;
      }
      const visible = visiblePages();
      spread.innerHTML = '';
      spread.classList.toggle('is-double', visible.length === 2);
      spread.style.transform = `scale(${zoom})`;
      viewport?.classList.toggle('is-zoomed', zoom > 1.001);

      visible.forEach((pageNo, index) => {
        const cls = visible.length === 1 ? 'is-single' : (index === 0 ? 'is-left' : 'is-right');
        const el = createPage(pageNo, cls);
        if (direction) el.classList.add(direction === 'next' ? 'is-turning-next' : 'is-turning-prev');
        spread.appendChild(el);
      });

      const prevButtons = [qs(root, '[data-aot-prev]'), qs(root, '[data-aot-prev-mobile]')];
      const nextButtons = [qs(root, '[data-aot-next]'), qs(root, '[data-aot-next-mobile]')];
      prevButtons.forEach(btn => { if (btn) btn.disabled = current <= 1; });
      nextButtons.forEach(btn => { if (btn) btn.disabled = current >= pages.length; });

      if (counter) counter.textContent = visible.length === 2 ? `${visible[0]}–${visible[1]} / ${pages.length}` : `${visible[0]} / ${pages.length}`;
      if (progress) progress.style.width = `${((visible[visible.length - 1] || 1) / pages.length) * 100}%`;
      updateThumbs();
    }

    function go(delta) {
      if (!pages.length) return;
      const step = isMobile() ? 1 : (current === 1 || current >= pages.length - 1 ? 1 : 2);
      const previous = current;
      current = Math.max(1, Math.min(pages.length, current + delta * step));
      if (current === previous) return;
      render(delta > 0 ? 'next' : 'prev');
      viewport?.scrollTo({ top: 0, left: 0, behavior: reduceMotion() ? 'auto' : 'smooth' });
      track('aot_brochure_page_change', { brochure_page: current });
    }

    function setZoom(value) {
      zoom = Math.max(.8, Math.min(2.2, value));
      if (spread) spread.style.transform = `scale(${zoom})`;
      viewport?.classList.toggle('is-zoomed', zoom > 1.001);
      if (zoomLabel) zoomLabel.textContent = `${Math.round(zoom * 100)}%`;
      track('aot_brochure_zoom', { zoom_percent: Math.round(zoom * 100) });
    }

    function buildThumbs() {
      if (!thumbsList) return;
      thumbsList.innerHTML = '';
      pages.forEach((item, index) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'aot-brochure__thumb';
        btn.dataset.page = String(index + 1);
        btn.innerHTML = `<img src="${item.src}" alt="${T.page} ${index + 1}" loading="lazy"><span>${index + 1}</span>`;
        btn.addEventListener('click', () => {
          current = index + 1;
          closeDrawer();
          render();
          track('aot_brochure_thumbnail_click', { brochure_page: current });
        });
        thumbsList.appendChild(btn);
      });
    }

    function updateThumbs() {
      const visible = visiblePages();
      qsa(root, '.aot-brochure__thumb').forEach(btn => btn.classList.toggle('is-active', visible.includes(Number(btn.dataset.page))));
    }

    function openDrawer() {
      drawer?.classList.add('is-open');
      drawer?.setAttribute('aria-hidden', 'false');
      scrim?.classList.add('is-show');
      track('aot_brochure_thumbnails_open');
    }
    function closeDrawer() {
      drawer?.classList.remove('is-open');
      drawer?.setAttribute('aria-hidden', 'true');
      if (!modal?.classList.contains('is-show')) scrim?.classList.remove('is-show');
    }

    let modalReturnFocus = null;
    function openModal(title, meta = '') {
      if (!modal) return;
      if (!modal.classList.contains('is-show')) modalReturnFocus = document.activeElement;
      modalTitle.textContent = title;
      modalMeta.textContent = meta;
      modal.classList.add('is-show');
      modal.setAttribute('aria-hidden', 'false');
      scrim?.classList.add('is-show');
      qs(modal, 'button')?.focus();
    }
    function closeModal() {
      const wasOpen = modal?.classList.contains('is-show');
      modal?.classList.remove('is-show');
      modal?.setAttribute('aria-hidden', 'true');
      if (modalBody) modalBody.innerHTML = '';
      if (modalMeta) modalMeta.textContent = '';
      if (!drawer?.classList.contains('is-open')) scrim?.classList.remove('is-show');
      if (wasOpen && modalReturnFocus && typeof modalReturnFocus.focus === 'function' && document.contains(modalReturnFocus)) modalReturnFocus.focus();
      modalReturnFocus = null;
    }

    function showGallery() {
      if (!gallery.length || !modalBody) return;
      const item = gallery[galleryIndex];
      modalBody.innerHTML = '';
      modalMeta.textContent = `${galleryIndex + 1} / ${gallery.length}`;
      const img = document.createElement('img');
      img.src = item.src;
      img.alt = item.alt || '';
      modalBody.appendChild(img);
      if (gallery.length > 1) {
        const prev = document.createElement('button');
        prev.type = 'button'; prev.className = 'aot-brochure__gallery-nav is-prev'; prev.textContent = '‹'; prev.setAttribute('aria-label', T.previous_image);
        prev.onclick = () => { galleryIndex = (galleryIndex - 1 + gallery.length) % gallery.length; showGallery(); };
        const next = document.createElement('button');
        next.type = 'button'; next.className = 'aot-brochure__gallery-nav is-next'; next.textContent = '›'; next.setAttribute('aria-label', T.next_image);
        next.onclick = () => { galleryIndex = (galleryIndex + 1) % gallery.length; showGallery(); };
        modalBody.append(prev, next);
      }
    }
    function openGallery(pageNo) {
      if (!gallery.length) return;
      galleryIndex = 0;
      openModal(T.team_company, `1 / ${gallery.length}`);
      showGallery();
      track('aot_brochure_gallery_open', { brochure_page: pageNo });
    }

    function openVideo(source = 'toolbar', pageNo = null) {
      const template = qs(root, '[data-aot-video-template]');
      if (!template || !modalBody) return;
      openModal(T.company_film);
      modalBody.innerHTML = '';
      modalBody.appendChild(template.content.cloneNode(true));
      const video = qs(modalBody, 'video');
      if (video) {
        video.addEventListener('play', () => track('aot_brochure_video_play', { source, brochure_page: pageNo }), { once: true });
        video.addEventListener('ended', () => track('aot_brochure_video_complete', { source, brochure_page: pageNo }), { once: true });
      }
      track('aot_brochure_video_open', { source, brochure_page: pageNo });
    }

    function openContact(pageNo) {
      track('aot_brochure_contact_click', { brochure_page: pageNo });
      if (root.dataset.contactEnabled === 'true') {
        const anchor = document.getElementById(root.dataset.contactAnchor);
        anchor?.scrollIntoView({ behavior: reduceMotion() ? 'auto' : 'smooth', block: 'start' });
      } else if (root.dataset.contactEmail) {
        window.location.href = `mailto:${root.dataset.contactEmail}?subject=AOT%20Food%20Ingredients%20Anfrage`;
      }
    }

    async function share() {
      if (navigator.share) {
        try { await navigator.share({ title: document.title, url: location.href }); track('aot_brochure_share', { method: 'native' }); return; } catch (e) {}
      }
      try { await navigator.clipboard.writeText(location.href); showToast(T.link_copied); track('aot_brochure_share', { method: 'clipboard' }); }
      catch (e) { showToast(T.link_copy_failed); }
    }

    function toggleFullscreen() {
      if (!document.fullscreenElement) {
        viewerCard?.requestFullscreen?.();
        track('aot_brochure_fullscreen', { state: 'enter' });
      } else {
        document.exitFullscreen?.();
        track('aot_brochure_fullscreen', { state: 'exit' });
      }
    }

    qs(root, '[data-aot-prev]')?.addEventListener('click', () => go(-1));
    qs(root, '[data-aot-next]')?.addEventListener('click', () => go(1));
    qs(root, '[data-aot-prev-mobile]')?.addEventListener('click', () => go(-1));
    qs(root, '[data-aot-next-mobile]')?.addEventListener('click', () => go(1));
    qs(root, '[data-aot-thumbs]')?.addEventListener('click', openDrawer);
    qs(root, '[data-aot-drawer-close]')?.addEventListener('click', closeDrawer);
    qs(root, '[data-aot-modal-close]')?.addEventListener('click', closeModal);
    qs(root, '[data-aot-hotspots]')?.addEventListener('click', () => {
      root.classList.toggle('is-hotspots');
      const on = root.classList.contains('is-hotspots');
      showToast(on ? T.areas_visible : T.areas_hidden);
      track('aot_brochure_hotspots_toggle', { visible: on });
    });
    qsa(root, '[data-aot-video-open]').forEach(btn => btn.addEventListener('click', () => openVideo('toolbar')));
    qs(root, '[data-aot-share]')?.addEventListener('click', share);
    qs(root, '[data-aot-fullscreen]')?.addEventListener('click', toggleFullscreen);
    qs(root, '[data-aot-zoom-out]')?.addEventListener('click', () => setZoom(zoom - .15));
    qs(root, '[data-aot-zoom-in]')?.addEventListener('click', () => setZoom(zoom + .15));
    qsa(root, '[data-aot-track]').forEach(el => el.addEventListener('click', () => track(`aot_brochure_${el.dataset.aotTrack || 'click'}`)));
    scrim?.addEventListener('click', () => { closeDrawer(); closeModal(); });

    viewport?.addEventListener('touchstart', e => { touchX = e.changedTouches[0].clientX; }, { passive: true });
    viewport?.addEventListener('touchend', e => { const dx = e.changedTouches[0].clientX - touchX; if (Math.abs(dx) > 55) go(dx < 0 ? 1 : -1); }, { passive: true });

    viewport?.addEventListener('keydown', e => {
      if (e.key === 'ArrowRight') go(1);
      if (e.key === 'ArrowLeft') go(-1);
    });

    document.addEventListener('keydown', e => {
      if (!modal?.classList.contains('is-show')) return;
      if (e.key === 'Escape') closeModal();
      if (gallery.length && e.key === 'ArrowRight') { galleryIndex = (galleryIndex + 1) % gallery.length; showGallery(); }
      if (gallery.length && e.key === 'ArrowLeft') { galleryIndex = (galleryIndex - 1 + gallery.length) % gallery.length; showGallery(); }
    });

    const resizeObserver = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(() => render()) : null;
    if (resizeObserver && viewerCard) resizeObserver.observe(viewerCard);

    buildThumbs();
    render();
    track('aot_brochure_initialized', { page_count: pages.length });
  }

  function initAll(scope = document) {
    if (scope.matches?.(SELECTOR)) init(scope);
    scope.querySelectorAll?.(SELECTOR).forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();

  document.addEventListener('shopify:section:load', event => initAll(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
